// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","shell":"App_shell__1G2Ca","content":"App_content__wwONY","locked":"App_locked__CkUG-","ontop":"App_ontop__zSwt6"};